import { render, staticRenderFns } from "./CustomerQuotesEdit.vue?vue&type=template&id=25dafd60&"
import script from "./CustomerQuotesEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerQuotesEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerQuotesEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports